import { render } from "./VolunteeringStyledModal.vue?vue&type=template&id=575779d2&scoped=true"
import script from "./VolunteeringStyledModal.vue?vue&type=script&lang=js"
export * from "./VolunteeringStyledModal.vue?vue&type=script&lang=js"

import "./VolunteeringStyledModal.vue?vue&type=style&index=0&id=575779d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-575779d2"

export default script